export const SET_ECOMMERCE_LIST = "@ECOMMERCE/SET_LIST";
export const SET_ECOMMERCE_DATA_SOURCE_LIST = "@ECOMMERCE/SET_DATA_SOURCE_LIST";
export const SET_SHOPIFY_INTEGRATIONS = "@ECOMMERCE/SET_SHOPIFY_INTEGRATIONS";
